/**
 * HeadingAnchor Stimulus Controller
 *
 * Scans headings (h1–h6) that have IDs and injects a click-to-copy anchor
 * link next to each one. Clicking copies the full URL (with #anchor) to the
 * clipboard and briefly shows a "Copied!" tooltip.
 */

import { Controller } from '@hotwired/stimulus';
import application from '~/stimulus_application';

export default class HeadingAnchor extends Controller {
  connect() {
    this.element
      .querySelectorAll<HTMLElement>('h1[id], h2[id], h3[id], h4[id], h5[id], h6[id]')
      .forEach((heading) => {
        const id = heading.id;

        heading.style.position = 'relative';

        const comrakAnchor = heading.querySelector<HTMLElement>(':scope > a.anchor');
        comrakAnchor?.setAttribute('aria-hidden', 'true');
        comrakAnchor?.setAttribute('tabindex', '-1');

        const copyBtn = document.createElement('a');
        copyBtn.href = `#${id}`;
        copyBtn.setAttribute('aria-label', 'Copy link to section');
        copyBtn.style.cssText =
          'position:absolute;right:100%;top:50%;transform:translateY(-50%);padding-right:0.4rem;display:inline-flex;align-items:center;opacity:0;transition:opacity 0.15s;color:#9ca3af;text-decoration:none;';
        copyBtn.innerHTML =
          '<svg xmlns="http://www.w3.org/2000/svg" style="width:1.1rem;height:1.1rem;" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M13.828 10.172a4 4 0 010 5.656l-3 3a4 4 0 01-5.656-5.656l1.5-1.5M10.172 13.828a4 4 0 010-5.656l3-3a4 4 0 015.656 5.656l-1.5 1.5" /></svg>';

        heading.addEventListener('mouseenter', () => {
          copyBtn.style.opacity = '1';
        });
        heading.addEventListener('mouseleave', () => {
          copyBtn.style.opacity = '0';
        });

        copyBtn.addEventListener('click', (e) => {
          e.preventDefault();
          const url = `${window.location.origin}${window.location.pathname}#${id}`;
          navigator.clipboard.writeText(url).then(() => {
            this.showCopiedFeedback(copyBtn);
          });
        });

        heading.appendChild(copyBtn);
      });
  }

  private showCopiedFeedback(btn: HTMLAnchorElement) {
    const original = btn.innerHTML;
    btn.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" style="width:1.1rem;height:1.1rem;color:#22c55e;" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" /></svg>';
    btn.style.opacity = '1';
    setTimeout(() => {
      btn.innerHTML = original;
      btn.style.opacity = '0';
    }, 1500);
  }
}

application.register('ui--heading-anchor', HeadingAnchor);
